<template>
    <div>
        <div @click.stop.prevent="ShowAlertWhenBackInStock=true" class="pointer">Giv mig besked når varen er på lager igen</div>
        <b-modal v-model="ShowAlertWhenBackInStock" cancel-title="Annuller" ok-title="Ok" @ok="SubscribeToRestock()" title="Giv mig besked når varen er på lager igen">
            Angiv dine oplysninger nedenfor, så sender vi en besked, når varen er på lager igen<br>
            <br>
            <b-form-group label="Navn:" label-for="navn">
                <b-form-input id="navn" v-model="name" />
            </b-form-group>
            <b-form-group label="Telefonnummer:" label-for="telefonnummer">
                <b-form-input id="telefonnummer" v-model="phone" />
            </b-form-group>
            <b-form-group label="Email adresse:" label-for="email">
                <b-form-input id="email" v-model="email" />
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props:["item"],
    methods:{
        SubscribeToRestock(){
            var data = {
                itemNo : this.item.No,
                itemDescription : this.item.Description,
                url : document.location.origin + this.item.Url,
                name : this.name,
                email : this.email,
                phone : this.phone
            };
            return axios.post("/umbraco/surface/bshop/SubscribeToRestock", data).then((res)=>{
                return;
            });
            alert("okie");
        }
    },
    data(){
        return {
            ShowAlertWhenBackInStock : false,
            name : "",
            email : "",
            phone : "",
        }
    },
}
</script>